export default "__VITE_ASSET__DeFz1sd5__"